var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKontrakSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49915 17.5031H4.16443C3.24357 17.5031 2.49707 16.7566 2.49707 15.8357V4.16419C2.49707 3.24333 3.24357 2.49683 4.16443 2.49683H14.1686C15.0895 2.49683 15.836 3.24333 15.836 4.16419V6.66523",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.5031L12.1876 17.233C12.3415 17.214 12.4847 17.1442 12.5944 17.0346L17.895 11.7341C18.482 11.1495 18.4843 10.1997 17.9 9.61234L17.895 9.60817V9.60817C17.3104 9.02108 16.3606 9.01884 15.7732 9.60317V9.60817L10.5211 14.8604C10.4142 14.9665 10.3451 15.1047 10.3243 15.2539L10 17.5031Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66556 14.1684V14.1684C5.97492 14.1684 5.41504 13.6085 5.41504 12.9179V12.9179C5.41504 12.2272 5.97492 11.6674 6.66556 11.6674V11.6674C7.3562 11.6674 7.91608 12.2272 7.91608 12.9179V12.9179C7.91608 13.6085 7.3562 14.1684 6.66556 14.1684Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41504 5.83164H12.0845",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41504 8.74948H8.74976",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontrakSelected);
export default __webpack_public_path__ + "static/media/kontrakSelected.7a5352d4e0c091fa31c68b8254b875e6.svg";
export { ForwardRef as ReactComponent };